import { render, staticRenderFns } from "./UpLoadModel.vue?vue&type=template&id=62579d76&scoped=true&"
import script from "./UpLoadModel.vue?vue&type=script&lang=js&"
export * from "./UpLoadModel.vue?vue&type=script&lang=js&"
import style0 from "./UpLoadModel.vue?vue&type=style&index=0&id=62579d76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62579d76",
  null
  
)

export default component.exports